import { QBankStructureLevelCategory } from '@exam-management/graphql';
import kebabCase from 'lodash/kebabCase';
import upperFirst from 'lodash/upperFirst';

const QBankStructureLevelLabel = {
  [QBankStructureLevelCategory.Course]: 'หลักสูตร',
  [QBankStructureLevelCategory.Part]: 'หมวด',
  [QBankStructureLevelCategory.Subject]: 'เล่ม/วิชา',
  [QBankStructureLevelCategory.Group]: 'ส่วนที่',
  [QBankStructureLevelCategory.Chapter]: 'บท',
  [QBankStructureLevelCategory.Topic]: 'หัวข้อ',
  [QBankStructureLevelCategory.SubTopic]: 'หัวข้อย่อย',
};

export function getQBankStructureLevelLabelByCategory(
  category: QBankStructureLevelCategory,
  options: {
    withEng?: boolean;
  } = {},
) {
  const { withEng = false } = options;

  if (withEng) {
    return `${QBankStructureLevelLabel[category]} (${upperFirst(kebabCase(category))})`;
  } else {
    return QBankStructureLevelLabel[category];
  }
}

const qBankStructureLevelColorByCategory = {
  [QBankStructureLevelCategory.Course]: 'hsla(39, 100%, 90%, 1)',
  [QBankStructureLevelCategory.Part]: 'hsla(207, 100%, 90%, 1)',
  [QBankStructureLevelCategory.Subject]: 'hsla(263, 100%, 90%, 1)',
  [QBankStructureLevelCategory.Group]: 'hsla(0, 76%, 90%, 1)',
  [QBankStructureLevelCategory.Chapter]: 'hsla(131, 53%, 90%, 1)',
  [QBankStructureLevelCategory.Topic]: 'hsla(31, 96%, 90%, 1)',
  [QBankStructureLevelCategory.SubTopic]: 'hsla(318, 100%, 93%, 1)',
};

export function getQBankStructureLevelColorByCategory(category: QBankStructureLevelCategory) {
  return qBankStructureLevelColorByCategory[category];
}
